import { createContext } from 'react'

const StepsContext = createContext()

const StepsContextProvider = ({ children, value }) => {
  return <StepsContext.Provider value={value}>{children}</StepsContext.Provider>
}

export { StepsContext, StepsContextProvider }
